import React, { useEffect } from 'react'
import { Button, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Radio, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@mui/styles'
import CustomHeader from '../../components/CustomHeader'
import Section from '../../components/CustomSection'
import CustomRadioButtonGroup from '../../components/CustomRadioButtonGroup';
import { getLogo } from '../../utils/commons'
import { dataUtil, usage_type } from '../../services/wsclients/dataUtil'
import CustomSection from '../../components/CustomSection'
import { paths } from '../../config/router.config'
import { useHistory } from 'react-router-dom'
import CustomCircularProgress from '../../components/CustomCircularProgress'

const useStyles = makeStyles((theme) => ({
    package: {
        width: '100%',
        height: 300,
        objectFit: 'contain'
    },
    content: {
        padding: theme.spacing(2),
        paddingTop: theme.spacing(10),
    },
    support_device: {
        width: '60%',
        height: 'auto',
        objectFit: 'contain'
    },
    list_device: {
        justifyContent: 'center',
        marginTop: theme.spacing(2),
        textAlign: 'center',
    },
    device: {
        cursor: 'pointer',
    },
    device_info: {
        textAlign: 'center',
    },
    device_image: {
        width: '100%',
        height: 100,
        objectFit: 'contain',
    },
    device_select: {
        textAlign: 'center',
    }
}));

export default function PackageInfoView(props) {
    const { packageInfo, currency, physicalGoods, physicalGoodSelected, paymentMethodSelected, setPaymentMethodSelected, loadingPrice } = props;
    const { t } = useTranslation();
    const classes = useStyles();
    const history = useHistory();
    let discountedInstallation = document._portalConfig.discountedInstallation ? document._portalConfig.discountedInstallation : 0;
    let activationFees = document._portalConfig.activationFees ? document._portalConfig.activationFees : 0;

    let routerFees = document._portalConfig.routerFees ? document._portalConfig.routerFees : 0;
    let deliveryFees = document._portalConfig.deliveryFees ? document._portalConfig.deliveryFees : 0;
    let promo = document._portalConfig.promo ? document._portalConfig.promo : 0;
    let price = 0;
    // console.log("AAAA PackageInfoView price: ", price)
    if (packageInfo) {
        if (props.selected == '1') {
            price = packageInfo.price_o ? packageInfo.price_o : packageInfo.price;
        } else if (props.selected == '2') {
            price = packageInfo.price_r ? packageInfo.price_r : packageInfo.price;
        }
    }
    let totalAmount = price ? Number(price) : 0;
    totalAmount += discountedInstallation + activationFees + routerFees + deliveryFees - promo;

    let discountedInstallationText = document._portalConfig.discountedInstallationText ? document._portalConfig.discountedInstallationText : null;
    let activationFeesText = document._portalConfig.activationFeesText ? document._portalConfig.activationFeesText : null;
    
    let discountedInstallationAndActivationFee = document._portalConfig.discountedInstallationAndActivationFee ? document._portalConfig.discountedInstallationAndActivationFee : 0;
    let discountedInstallationAndActivationFeeText = document._portalConfig.discountedInstallationAndActivationFeeText ? document._portalConfig.discountedInstallationAndActivationFeeText : 0;
    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, []);
    console.log("AAAA packageInfo: ", packageInfo)
    return (
        <Grid xs={12} item>
            {/* {props.from === paths.package_contact && <CustomHeader nomargin={true} hideMenu={true} />} */}
            <CustomHeader hideSignIn/>
            <Grid xs={12} item className={classes.content}>
                <Grid xs={12} item container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Section title={t('subscriptions')}>
                            {/* <img src={packageInfo.image_url} className={classes.package} /> */}
                            {/* <ProductImage classes={classes} image={dataUtil.getImageByUsageTypePortal(packageInfo.creatives, usage_type.product_item)} /> */}
                            {packageInfo && packageInfo.image_url ? <img className={classes.package} src={packageInfo.image_url} /> 
                            : <img className={classes.package} src={getLogo()} />}
                            <Grid xs={12} item container direction="row" justifyContent='center'>
                                {/* <Typography variant='body2'>{t('pro_data_amount')}:&nbsp;</Typography> */}
                                {/* <Typography variant='body2'>{currency}{packageInfo.amount}</Typography> */}
                                {/* <Typography variant='body2'>{currency}{packageInfo.price ? Number(packageInfo.price).toFixed(2) : "0.00"} (incl Vat)</Typography> */}
                            </Grid>
                            <Grid xs={12} item marginTop={1}>
                                {/* <Typography variant='caption'>{packageInfo.name}</Typography> */}
                            </Grid>
                        </Section>
                    </Grid>
                </Grid>
                {packageInfo && packageInfo.devices && packageInfo.devices.length > 0 && <Grid item xs={12} container justifyContent={"center"}>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Section title={t('devices_title')}>
                            <Typography>{t('please_select_device')}</Typography>
                            <Grid item xs={12} container className={classes.list_device}>
                                {packageInfo.devices.map((item, index) => {
                                    return (
                                        <Grid item xs={12} md={4} key={index}>
                                            <DeviceItem 
                                                classes={classes}
                                                t={t}
                                                item={item}
                                                currency={currency}
                                                deviceSelected={props.deviceSelected}
                                                onChangeDevice={props.onChangeDevice}
                                            />
                                        </Grid>
                                    )
                                })}
                            </Grid>
                        </Section>
                    </Grid>
                </Grid>}
                {/* <Grid xs={12} item container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Section title={t('physical_good')}>
                            <Grid xs={12} item container>
                                <CustomRadioButtonGroup items={physicalGoods} onChange={props.onSelectDevice} />
                            </Grid>
                            {physicalGoodSelected && physicalGoodSelected == 'sim' && <Grid xs={12} item>
                                <img src={"https://flyuat.crm.com/img/device_support.jpg"} className={classes.support_device} />
                            </Grid>}
                            {physicalGoodSelected && physicalGoodSelected == 'sim' && <Grid xs={12} item>
                                <FormGroup>
                                    <FormControlLabel control={<Checkbox />} label={t('confirm_select_device')} />
                                </FormGroup>
                            </Grid>}
                        </Section>
                    </Grid>
                </Grid> */}
                <Grid item xs={12} container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <BillPayment
                            t={t}
                            options={props.options}
                            selected={props.selected}
                            onChangeOption={props.onChangeOption}
                        />
                    </Grid>
                </Grid>
                <Grid item xs={12} container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <StoreCard
                            t={t}
                            options={props.storeCardOptions}
                            selected={props.storeCardSelectedOption}
                            onChangeOption={props.onChangeStoreCardOption}
                        />
                    </Grid>
                </Grid>
                {document._portalConfig.useEasyPay && <Grid item xs={12} container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <CustomSection
                            title={t('payment_method')}
                        >
                            <CustomRadioButtonGroup
                                items={[ 
                                    { value: 'PAYGATE', label: 'Paygate' }, 
                                    { value: 'EASYPAY', label: 'EasyPay' }
                                ]}
                                selected={paymentMethodSelected ? paymentMethodSelected : null}
                                onChange={(e) => setPaymentMethodSelected(e.target.value)}
                            />
                        </CustomSection>
                    </Grid>
                </Grid>}
                <Grid xs={12} item container justifyContent='center'>
                    <Grid xs={12} sm={12} md={12} lg={8} xl={6} item>
                        <Section title={t('your_selection')}>
                            <Grid xs={12} sm={12} md={12} lg={8} item container justifyContent={"flex-start"}>
                                <Typography variant='body2'>{t('your_selection_package_info')}</Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={2}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{packageInfo.name}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    {loadingPrice ? <CustomCircularProgress size={15}/> : <Typography variant='body2'>{currency}{price ? Number(price).toFixed(2) : "0.00"}</Typography>}
                                </Grid>
                            </Grid>
                            {/* <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={2} marginBottom={2}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('deliver_free')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{"0.00"}</Typography>
                                </Grid>
                            </Grid> */}
                            <Divider />
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={2}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('net_amount')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                {loadingPrice ? <CustomCircularProgress size={15}/> : <Typography variant='body2'>{currency}{price ? Number(price).toFixed(2) : "0.00"}</Typography>}
                                </Grid>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('free_router')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{routerFees.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                            {/* <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('discount')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{"0.00"}</Typography>
                                </Grid>
                            </Grid> */}
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{discountedInstallationAndActivationFeeText}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{discountedInstallationAndActivationFee.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                            {/* <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{activationFeesText}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{activationFees.toFixed(2)}</Typography>
                                </Grid>
                            </Grid> */}
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('free_fromo')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{promo.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('free_delivery')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    <Typography variant='body2'>{currency}{deliveryFees.toFixed(2)}</Typography>
                                </Grid>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={8} item container direction="row" justifyContent={"flex-start"} marginTop={1}>
                                <Grid xs={10} item container justifyContent={"flex-start"}>
                                    <Typography variant='body1'>{t('total_amount_due')}</Typography>
                                </Grid>
                                <Grid xs={2} item container justifyContent={"flex-start"}>
                                    {loadingPrice ? <CustomCircularProgress size={15}/> : <Typography variant='body2'>{currency}{totalAmount.toFixed(2)}</Typography>}
                                </Grid>
                            </Grid>
                        </Section>
                    </Grid>
                </Grid>
                <Grid xs={12} paddingTop={6} item>
                    <Grid item xs={12} textAlign='center'>
                        <Button variant="contained" color="primary" onClick={() => props.onGoBack()} className={classes.button}>{t('btn_back')}</Button>
                        <Button variant="contained" color="primary" onClick={props.onCheckOut} disabled={!props.enableCheckout} className={classes.button} style={{ marginLeft: 10 }}>{t('btn_check_out')}</Button>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

function ProductImage(props) {
    if (props.image && props.image.url) {
        return <img className={props.classes.package} src={props.image.url} />
    } return <img className={props.classes.package} src={getLogo()} />;
}

function BillPayment(props) {
    const { t, options, selected, onChangeOption } = props;

    return (
        <CustomSection
            title={t('choose_bill_payment')}
        >
            <CustomRadioButtonGroup
                items={options}
                selected={selected ? selected : null}
                onChange={onChangeOption}
            />
        </CustomSection>
    );
}

function StoreCard(props) {
    const { t, options, selected, onChangeOption } = props;

    return (
        <CustomSection
            title={t('store_card_option')}
        >
            <CustomRadioButtonGroup
                items={options}
                selected={selected ? selected : null}
                onChange={onChangeOption}
            />
        </CustomSection>
    );
}

function DeviceItem(props){
    const { item, t, classes, onChangeDevice, deviceSelected, currency } = props;
    let image = item.creatives ? dataUtil.getImageByUsageTypePortal(item.creatives, "AVATAR") : null;
    let price = item.pricing && item.pricing.length > 0 ? item.pricing[0] : null;
    return (
        <Grid item xs={12} className={classes.device} onClick={() => onChangeDevice(item)}>
            <Grid item xs={12}>
                {image && image.url ? <img className={props.classes.device_image} src={image.url} /> : <img className={props.classes.device_image} src={getLogo()} />}
            </Grid>
            <Grid item xs={12} className={classes.device_info}>
                <Typography>{item.name ? item.name : ''}</Typography>
                <Typography>{currency}{price && price.price ? Number(price.price.toFixed(2)) : "0.00"}</Typography>
            </Grid>
            <Grid item xs={12} className={classes.device_select}>
                <Radio
                    checked={deviceSelected && deviceSelected.id === item.id}
                    onChange={() => onChangeDevice(item)}
                    value={item.id}
                    name="radio-buttons"
                    inputProps={{ 'aria-label': item.id }}
                />
            </Grid>
        </Grid>
    )
}